<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Dashboard" title="Dashboard" />

		<div v-if="canShowDashboard">
			<div class="row">
				<div class="col-md-4 col-sm-6">
					<div class="card profile-box">
						<div class="card-body">
							<div class="media">
								<div class="media-body">
									<div class="greeting-user">
										<h4 class="f-w-600 mb-0">Welcome to <br>Airotrack Operations</h4>
										<p>Click the button to track service requests</p>
										<div class="whatsnew-btn">
											<button class="btn btn-outline-white" @click="scrollToSection">Service Requests</button>
										</div>
									</div>
								</div>
								<div>
									<div class="clockbox">
										<svg id="clock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
											<g id="face">
												<circle class="circle" cx="300" cy="300" r="253.9"></circle>
												<path class="hour-marks" d="M300.5 94V61M506 300.5h32M300.5 506v33M94 300.5H60M411.3 107.8l7.9-13.8M493 190.2l13-7.4M492.1 411.4l16.5 9.5M411 492.3l8.9 15.3M189 492.3l-9.2 15.9M107.7 411L93 419.5M107.5 189.3l-17.1-9.9M188.1 108.2l-9-15.6"></path>
												<circle class="mid-circle" cx="300" cy="300" r="16.2"></circle>
											</g>
											<g id="hour">
												<path class="hour-hand" d="M300.5 298V142"></path>
												<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
											</g>
											<g id="minute">
												<path class="minute-hand" d="M300.5 298V67"></path>
												<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
											</g>
											<g id="second">
												<path class="second-hand" d="M300.5 350V55"></path>
												<circle class="sizing-box" cx="300" cy="300" r="253.9"></circle>
											</g>
										</svg>
									</div>
									<div class="badge f-10 p-0" id="txt"></div>
								</div>
							</div>
							<div class="cartoon">
								<img class="img-fluid" src="@/assets/images/dashboard/cartoon.svg" alt="vector women with laptop" />
							</div>
						</div>
					</div>
				</div>

				<div class="col-xl-8 col-md-8 box-col-6 col-ed-8">
					<div class="row">
						<div class="col-xl-12">
							<div class="card growth-wrap">
								<div class="card-header card-no-border growth-header">
									<div class="header-top">
										<h5>Device Production Growth</h5>
										<div>
											<div class="dropdown">
												<select class="form-select" v-model="production_growth_year" @change="fetchDashboard">
													<option :value="2026">2026</option>
													<option :value="2025">2025</option>
													<option :value="2024">2024</option>
													<option :value="2023">2023</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<div class="card-body pt-0">
									<div class="growth-wrapper">
										<apexchart height="200" type="line" :options="apexDashboard.options6" :series="apexDashboard.series6"></apexchart>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="card mini-stats-wid">
						<div class="card-body">
							<div class="media mb-3">
								<div class="media-body">
									<p class="tild-head text-primary" style="font-weight: 800;">Service Requests</p>
								</div>

								<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
									<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">Today's</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{today_service_requests}}</h6>
									</span>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">This Week</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{week_service_requests}}</h6>
									</span>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">This Month</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{month_service_requests}}</h6>
									</span>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">Total</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{service_requests}}</h6>
									</span>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="card mini-stats-wid">
						<div class="card-body">
							<div class="media mb-3">
								<div class="media-body">
									<p class="tild-head text-primary" style="font-weight: 800;">Completed Service Requests</p>
								</div>

								<div class="float-end mm-cart-image text-primary" style="height: 52px; width: 50px;">
									<i class="icofont icofont-3x icofont icofont-chart-line-alt"></i>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">Today's</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{today_completed_servive_requests}}</h6>
									</span>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">This Week</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{week_completed_service_requests}}</h6>
									</span>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">This Month</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{month_completed_service_requests}}</h6>
									</span>
								</div>
							</div>

							<div class="media mb-2">
								<div class="media-body">
									<p class="mb-0 ">Total</p>
								</div>

								<div class="align-self-center ">
									<span class="float-end me-3">
										<h6 class="font-weight-400">{{completed_service_requests}}</h6>
									</span>
								</div>
							</div>

						</div>
					</div>
				</div>

			</div>
			
			<div class="row">

				<div class="col-xxl-12 box-col-12">
					<div class="card">
						<div class="card-header card-no-border">
							<div class="header-top">
								<div class="card-header-right-icon">
									<div class="dropdown">
										<select class="form-select" v-model="work_data_year" @change="fetchDashboard()">
											<option :value="2026">2026</option>
											<option :value="2025">2025</option>
											<option :value="2024">2024</option>
											<option :value="2023">2023</option>
										</select>

									</div>
								</div>
								
								<h5 class="m-0">Service Data</h5>

								<div class="card-header-right-icon">
									<div class="dropdown">
										<select class="form-select"  v-model="service_type" @change="fetchDashboard()">
											<option value="">All Type</option>
											<option :value="1">SIM Change</option>
											<option :value="2">Repair</option>
											<option :value="3">Replacement</option>
										</select>
									</div>
								</div>
									
							</div>
						</div>
						<div class="card-body pt-0">
							<div class="row m-0 overall-card overview-card">
								<div class="col-xl-12 col-md-12 col-sm-12 p-0 box-col-7">
									<div class="chart-right">
										<div class="row">
											<div class="col-xl-12">
												<div class="card-body p-0 pt-4">
													<ul class="balance-data  pt-5">
														<li>
															<span class="circle" style="background-color: #93f1e7;"></span><span class="f-light ms-1">SIM Change</span>
														</li>
														<li>
															<span class="circle" style="background-color: #ffe333;"></span><span class="f-light ms-1">Repair</span>
														</li>
														<li>
															<span class="circle" style="background-color: #ebeded;"></span><span class="f-light ms-1">Replacement</span>
														</li>
													</ul>
													<div class="current-sale-container order-container">
														<div class="overview-wrapper">
															<apexchart height="265" type="line" :options="ecomDashboard.options2" :series="ecomDashboard.series2"></apexchart>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>

		<div class="col-sm-12" id="deviceSearchSection">
			<div class="card">
				<div class="card-body">

					<form @submit.prevent="searchDevice" enctype="multipart/form-data">
						<div class="form theme-form">
							<div class="row">
								<div class="col-md-6">
									<div class="mb-3">
										<label class="control-label">Choose Device<span class="text-danger">*</span>(For renewal, sim change and other service)</label>
										<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No or Mobile" v-model="device_id" @keyup="searchDevice()"/>
										<div v-if="search_error" class="text-danger mt-1">{{ search_error }}</div>
									</div>
								</div>
								<div class="col-md-2"></div>
								<div class="col-md-2" style="margin-top: 30px;">
									<button class="btn btn-warning" @click="navigateToBuyBack">Buy Back</button>
								</div>
								<div class="col-md-2" style="margin-top: 30px;">
									<button class="btn btn-secondary" @click="navigateToReplacement">Replacement</button>
								</div>
							</div>

						</div>
					</form>

					<!-- Device Details Table Section -->
					<div v-if="device_list.length > 0" class="row mt-3">
						<div class="col-12">
							<div class="card">
								<div class="card-header d-flex justify-content-between align-items-center">
									<h5 class="mb-0">Device Details</h5>
									<button class="btn btn-outline-secondary btn-sm" @click="clearSearch">
										<i class="fa fa-times me-1"></i>Clear
									</button>
								</div>
								<div class="card-body">
									<div class="table-responsive">
										<table class="table table-bordered table-hover align-middle mb-0">
											<thead class="table-light">
												<tr>
													<th>#</th>
													<th>IMEI</th>
													<th>Vehicle No</th>
													<th>Mobile</th>
													<!--<th>Status</th>-->
													<th>Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(device, idx) in device_list" :key="device.imei">
													<td>{{ idx + 1 }}</td>
													<td>{{ device.imei }}</td>
													<td>{{ device.vehicle_no }}</td>
													<td>{{ device.mobile }}</td>
													<!--<td>
														<span class="badge" :class="device.status === 'Active' ? 'bg-success' : 'bg-danger'">
															{{ device.status }}
														</span>
													</td>-->
													<td>
														<router-link :to="{ name: 'device_detail', query: { imei: device.imei } }" class="btn btn-primary btn-sm me-2">Details</router-link>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="device_details" class="col-sm-12">
					<div class="card-body">

						<div class="row">
							<div class="col-lg-12 col-md-12 mt-3">
								<div header-class="bg-transparent border-light" class="border border-light">
									<h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
										Complaint Logs</h4>

									<div class="table-responsive product-table">
										<table class="display" id="basic-1">
											<thead>
												<tr align="center">
													<th>Sl.No</th>  
													<th>Date</th>
													<th>Type</th>
													<th>Remarks</th>
													<th>Materials Used</th>
												</tr>
											</thead>
											<tbody>
												<tr align="center">
													<td>1</td>
													<td>14 Jun 2025</td>
													<td>Repair</td>
													<td>Fixed with Material Updates</td>
													<td>Material 1 - 1 <br>
														Material 5 - 3 <br>
														Material 10 - 2 <br>
													</td>
												</tr>
												<tr align="center">
													<td>2</td>
													<td>12 Jun 2025</td>
													<td>SIM Change</td>
													<td></td>
													<td></td>
												</tr>
											
											</tbody>
										</table>
									</div>

								</div>
							</div>
						</div>

					</div>
				</div>		
			</div>
		</div>

	</div>
</template>

<script>
import '@/assets/css/custom.css';
import { apexDashboard } from '@/data/comon';

	export default {
		name: "Dashbord1",
		components: {},
		data() {
			return {

				interval: "",
				greeting: "",
				time: "",
				
				errors: {}, 
				token: "",
				service_type: "",
				work_data_year: new Date().getFullYear(), // default year
				production_growth_year: new Date().getFullYear(),

				offer_drop: 1,

				svgIcon1: "new-order",
				svgIcon2: "customers",
				svgIcon3: "sale",
				svgIcon4: "profit",

				ecomDashboard: {

					options1: {
						labels: ['Ongoing', 'Draw Pending', 'Completed'],

						chart: {
							type: 'donut',
							height: 300,
						},
						dataLabels: {
							enabled: false
						},
						legend: {
							position: 'bottom',
							fontSize: '14px',
							fontFamily: 'Rubik, sans-serif',
							fontWeight: 500,
							labels: {
								colors: ["var(--chart-text-color)"],
							},
							markers: {
								width: 6,
								height: 6,
							},
							itemMargin: {
								horizontal: 7,
								vertical: 0
							},
						},
						stroke: {
							width: 10,
							colors: ["var(--light2)"],
						},
						plotOptions: {
							pie: {
								expandOnClick: false,
								donut: {
									size: '83%',
									labels: {
										show: true,
										name: {
											offsetY: 4,
										},
										total: {
											show: true,
											fontSize: '20px',
											fontFamily: 'Rubik, sans-serif',
											fontWeight: 500,
											label: 7,
											formatter: () => 'Total Campaigns'
										}
									},
								}
							}
						},
						states: {
							normal: {
								filter: {
									type: 'none',
								}
							},
							hover: {
								filter: {
									type: 'none',
								}
							},
							active: {
								allowMultipleDataPointsSelection: false,
								filter: {
									type: 'none',
								}
							},
						},
						colors: ["var(--theme-deafult)", "#FFA941", "#54BA4A"],
						responsive: [{
								breakpoint: 1630,
								options: {
									chart: {
										height: 360
									},
								}
							},
							{
								breakpoint: 1584,
								options: {
									chart: {
										height: 400
									},
								}
							},
							{
								breakpoint: 1473,
								options: {
									chart: {
										height: 250
									},
								}
							},
							{
								breakpoint: 1425,
								options: {
									chart: {
										height: 270
									},
								}
							},
							{
								breakpoint: 1400,
								options: {
									chart: {
										height: 320
									},
								}
							},
							{
								breakpoint: 480,
								options: {
									chart: {
										height: 250
									},

								}
							}
						]
					},
					series1: [2,4,1],


					options2: {

						chart: {
							height: 300,
							type: 'line',
							stacked: false,
							toolbar: {
								show: false
							},
							dropShadow: {
								enabled: true,
								top: 2,
								left: 0,
								blur: 4,
								color: '#000',
								opacity: 0.08
							}
						},
						stroke: {
							width: [2, 2, 2, 2],
							curve: 'smooth'
						},
						grid: {
							show: true,
							borderColor: 'var(--chart-border)',
							strokeDashArray: 0,
							position: 'back',
							xaxis: {
								lines: {
									show: true
								}
							},
							padding: {
								top: 0,
								right: 0,
								bottom: 0,
								left: 0
							},
						},
						plotOptions: {
							bar: {
								columnWidth: '50%'
							}
						},
						colors: ["#93f1e7", "#ffe333", "#ebeded"],
						// "#93f1e7", "#0dcaf0"
						fill: {
							type: 'gradient',
							gradient: {
								shade: 'light',
								type: "vertical",
								opacityFrom: 0.4,
								opacityTo: 0,
								stops: [0, 100]
							}
						},
						labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						// labels: months
						
						markers: {
							discrete: [
								{
									seriesIndex: 0,
									dataPointIndex: 0,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, 
								{
									seriesIndex: 1,
									dataPointIndex: 0,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 0,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 1,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 1,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 1,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 2,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 2,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 2,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 3,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 3,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 3,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 4,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 4,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 4,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 5,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 5,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 5,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 6,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 6,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 6,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 7,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 7,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 7,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 8,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 8,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 8,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 9,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 9,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 9,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 10,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 10,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 10,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								{
									seriesIndex: 0,
									dataPointIndex: 11,
									fillColor: '#93f1e7',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								}, {
									seriesIndex: 1,
									dataPointIndex: 11,
									fillColor: '#ffe333',
									strokeColor: 'var(--white)',
									size: 5,
								},
								{
									seriesIndex: 2,
									dataPointIndex: 11,
									fillColor: '#ebeded',
									strokeColor: 'var(--white)',
									size: 5,
									sizeOffset: 3
								},
								
							],
							hover: {
								size: 5,
								sizeOffset: 0
							}
						},
						xaxis: {
							type: 'category',
							tickAmount: 10,
							tickPlacement: 'between',
							tooltip: {
								enabled: false,
							},
							axisBorder: {
								color: 'var(--chart-border)',
							},
							axisTicks: {
								show: false
							}
						},
						legend: {
							show: false,
						},
						yaxis: {
							min: 0,
							tickAmount: 6,
							tickPlacement: 'between',
						},
						tooltip: {
							shared: false,
							intersect: false,
						},
						responsive: [{
							breakpoint: 1200,
							options: {
								chart: {
									height: 250,
								}
							},
						}]

					},
					series2: [
						{
							name: 'SIM Change',
							type: 'area',
							data: []
						},
						{
							name: 'Repair',
							type: 'area',
							data: []
						},
						{
							name: 'Replacement',
							type: 'area',
							data: []
						},
						
					],

				},

				apexDashboard: {

					options6: {

						chart: {
							height: 135,
							type: 'line',
							toolbar: {
								show: false
							},
							dropShadow: {
								enabled: true,
								enabledOnSeries: undefined,
								top: 5,
								left: 0,
								blur: 4,
								color: '#7366ff',
								opacity: 0.22
							},
						},
						grid: {
							yaxis: {
								lines: {
									show: false
								}
							},
						},
						colors: ["#5527FF"],
						stroke: {
							width: 3,
							curve: 'smooth'
						},
						xaxis: {
							type: 'category',
							categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
							tickAmount: 10,
							labels: {
								style: {
									fontFamily: 'Rubik, sans-serif',
								},
							},
							axisTicks: {
								show: false
							},
							axisBorder: {
								show: false
							},
							tooltip: {
								enabled: false,
							},
						},
						fill: {
							type: 'gradient',
							gradient: {
								shade: 'dark',
								gradientToColors: ['#5527FF'],
								shadeIntensity: 1,
								type: 'horizontal',
								opacityFrom: 1,
								opacityTo: 1,
								colorStops: [{
										offset: 0,
										color: "#5527FF",
										opacity: 1
									},
									{
										offset: 100,
										color: "#E069AE",
										opacity: 1
									},
								]
							},
						},
						yaxis: {
							min: -10,
							max: 4000,
							labels: {
								show: false
							}
						},
						responsive: [{
								breakpoint: 992,
								options: {
									chart: {
										height: 150,
									}
								},
							},
							{
								breakpoint: 768,
								options: {
									chart: {
										height: 200,
									}
								},
							}
						]
					},
					series6: [{
						name: 'Growth',
						data: [2052, 1589, 2815, 2077, 3015, 2112, 0, 0, 0, 0, 0, 0]
					}],
				},
				
				today_service_requests: "",
				week_service_requests: "",
				month_service_requests: "",
				service_requests: "",

				today_completed_servive_requests: "",
				week_completed_service_requests: "",
				month_completed_service_requests: "",
				completed_service_requests: "",

				new_work_data: [],
				repair_work_data: [],
				replacement_work_data: [],

				expense: {
					svgIcon : "expense",
					title :  "Expense",
					total_expense : "",
				},
				
				income: {
					svgIcon : "orders",
					title :  "Income",
					total_income : "",
				},

				months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

				iconClassDown: "font-danger ms-2",
    			trandingClassDown: "trending-down",

				iconClassUp: "font-success ms-2",
				trandingClassUp: "trending-up",

				complaint_type: "",
				device_id: "",
				device_list: [],
				search_error: "",
				searchTimeout: null,
				role_id: null

			};

		},

		computed: {
			canShowDashboard() {
				return this.role_id === 5 || this.role_id === 6;
			}
		},

		created(){
			this.fetchDashboard();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchDashboard(page_url = null) {
			try {
				// Build query string safely
				const params = new URLSearchParams({
					production_growth_year: this.production_growth_year || "",
					work_data_year: this.work_data_year || "",
					service_type: this.service_type || ""
				}).toString();

				// Always use a string URL
				const url = `/staffs/dashboard?${params}`;
				const finalUrl = page_url || url;

				this.getToken();

				this.$axios
					.get(finalUrl, {
						headers: { Authorization: `Bearer ${this.token}` }
					})
					.then((res) => {
						const responseData = res.data.data;
						console.log("Dashboard response:", responseData);

						// Extract role_id from user_data
						this.role_id = responseData.user_data?.role_id || null;

						this.today_service_requests = responseData.today_service_requests;
						this.week_service_requests = responseData.week_service_requests;
						this.month_service_requests = responseData.month_service_requests;
						this.service_requests = responseData.service_requests;

						this.today_completed_servive_requests = responseData.today_completed_servive_requests;
						this.week_completed_service_requests = responseData.week_completed_service_requests;
						this.month_completed_service_requests = responseData.month_completed_service_requests;
						this.completed_service_requests = responseData.completed_service_requests;

						// Work Data
						const wd = responseData.work_data || {};
						this.new_work_data = wd["SIM Change"] ?? wd["sim change"] ?? [];
						this.repair_work_data = wd["Repair"] ?? wd["repair"] ?? [];
						this.replacement_work_data = wd["Replacement"] ?? wd["replacement"] ?? [];

						// Update ApexChart dynamically
						this.ecomDashboard.series2 = [
							{ name: "SIM Change", type: "area", data: this.new_work_data },
							{ name: "Repair", type: "area", data: this.repair_work_data },
							{ name: "Replacement", type: "area", data: this.replacement_work_data },
						];
					})
					.catch((err) => {
						console.error("Dashboard fetch error:", err);
					});
			} catch (error) {
				console.error("fetchDashboard failed:", error);
			}
		},


			scrollToSection() {
				const section = document.getElementById('deviceSearchSection');
				if (section) {
					const topOffset = section.getBoundingClientRect().top + window.scrollY - 100; // Calculate the exact position with offset
					window.scrollTo({
						top: topOffset,
						behavior: 'smooth',
					});
				}
			},

			searchDevice() {
				if (!this.device_id.trim()) {
					this.search_error = "";
					this.device_list = [];
					return;
				}

				// Clear previous timeout
				if (this.searchTimeout) {
					clearTimeout(this.searchTimeout);
				}

				// Debounce search
				this.searchTimeout = setTimeout(() => {
					this.search_error = "";
					this.device_list = [];
					this.getToken();

					let url = "/staffs/searchDevice";

					this.$axios.get(url, {
						params: {
							imei: this.device_id,
							vehicle_no: this.device_id,
							mobile: this.device_id
						},
						headers: {
							Authorization: "Bearer " + this.token
						}
					})
					.then((response) => {
						if (response.data.status === 'true') {
							this.device_list = response.data.data.map((device) => ({
								imei: device.imei,
								vehicle_no: device.vehicle_number,
								mobile: device.mobile,
								status: "Active"
							}));
							this.search_error = "";
						} else {
							this.search_error = response.data.message || "No matching devices found";
						}
					})
					.catch((error) => {
						if (error.response && error.response.data && error.response.data.message) {
							this.search_error = error.response.data.message;
						} else {
							this.search_error = "An error occurred while searching";
						}
						console.error("Search error:", error);
					});
				}, 500);
			},



			clearSearch() {
				if (this.searchTimeout) {
					clearTimeout(this.searchTimeout);
				}
				this.device_id = "";
				this.device_list = [];
				this.search_error = "";
				this.complaint_type = "";
			},
			goToDevice(imei) {
				this.$router.push({ name: 'device-detail', params: { imei } });
			},
			navigateToBuyBack() {
				this.$router.push({ name: 'add_buy_back_device' });
			},
			navigateToReplacement() {
				this.$router.push({ name: 'add_replacement_device' });
			}
		},

		
	};
</script>

<style>
	html {
	scroll-behavior: smooth;
	}
</style>

